import BaseApiCall from "./BaseApiCall";
import axios from "axios";
import apiConfig from "../api/apiConfig";

export const getTicketSearchFields = async (organizationId) => {

    try {
        const response = await BaseApiCall.get('/tickets/search-form');
        return response.data;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const getCustomerFormFields = async (organizationId) => {

    try {
        const response = await BaseApiCall.get('/tickets/customer-form');
        return response.data;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const getTicketFormFields = async (type) => {

    try {
        const response = await BaseApiCall.get('/tickets/ticket-form', {
            params: { type },
        });
        return response.data;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const findCustomerInfo = async (query) => {
    try {
        const response = await BaseApiCall.post('/customer/find-customer-info', { query: query });
        return response.data;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const submitTicket = async (payload) => {
    console.log(payload);
    try {
        const response = await BaseApiCall.post('/tickets/save', payload);
        console.error(response);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const loadTickets = async (params) => {
    try {
        const response = await BaseApiCall.post("/tickets/load-ticket", params);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const loadMyTickets = async (params) => {
    try {
        const response = await BaseApiCall.post("/tickets/load-my-ticket", params);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const loadAssignedTickets = async (params) => {
    try {
        const response = await BaseApiCall.post("/tickets/load-assinged-ticket", params);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const getTicketFormById = async (id) => {
    console.log("id", id)
    try {
        const response = await BaseApiCall.get(`/tickets/update-form?ticketId=${id}`);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const updateTickets = async (payload) => {
    try {
        const response = await BaseApiCall.post('/tickets/update', payload);
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const loadTicketSummary = async (startDate, endDate) => {
    try {
        let url = "/tickets/load-summary";
        // if (startDate && endDate) {
        //     url += `?startDate=${startDate}&endDate=${endDate}`;
        // }
        const response = await BaseApiCall.get(url);
        return response;
    } catch (error) {
        console.error("Loading error:", error.message);
        if (error.response) {
            console.error("Response data:", error.response.data);
            console.error("Response status:", error.response.status);
        }
        throw error;
    }
}

export const getTicketSummaryByCreator = async () => {
    try {
        const response = await BaseApiCall.get("/tickets/get-summary-by-creator");
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const getTicketDetails = async (id) => {
    try {
        const response = await axios.get(`${apiConfig.baseUrl}/info/get-ticket-details`, {
            params: { id },
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        console.error('Error fetching ticket details:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};